export default "__VITE_ASSET__BJTSPkVo__"